import React, { useState } from "react";
import styled from "styled-components";

import Content from "./Content";
import contentData from "./contentData";

const Container = styled.div``;

const Drawer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: #424242;
  opacity: 0.95;
  max-width: 360px;
  width: 100%;
  height: 100vh;
  z-index: 100;
  transition: left 0.25s ease-in-out;
  border-right: 1px solid #b0bec5;
  overflow-y: scroll;
  box-sizing: border-box;

  ${({ isDrawerShown }) => `
    left: ${isDrawerShown ? `0` : `-360px`} ;
    border-right: ${isDrawerShown ? `1px solid #b0bec5` : `none`}
  `}
`;

const CircleButton = styled.button`
  background-color: transparent;
  border: 2px solid #fff;
  border-radius: 50%;
  color: #fff;
  font-weight: 700;
  font-size: 1.2em;
  width: 32px;
  height: 32px;
  cursor: pointer;
  opacity: 0.7;

  &:hover {
    opacity: 0.9;
  }
`;

const ButtonManual = styled(CircleButton)`
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 101;
`;

const Manual = () => {
  const [isDrawerShown, setIsDrawerShown] = useState(false);

  const handleDrawerShow = () => {
    setIsDrawerShown(!isDrawerShown);
  };

  return (
    <Container>
      <Drawer isDrawerShown={isDrawerShown}>
        <Content {...contentData} />
      </Drawer>
      <ButtonManual className="btn-manual" onClick={handleDrawerShow}>
        {isDrawerShown ? "x" : "?"}
      </ButtonManual>
    </Container>
  );
};

export default Manual;
